import { isTwa } from '../marketing/utils/isInstalledApp';

export const primeWebNotificationPermission = async (): Promise<NotificationPermission | null> => {
  if (typeof window === 'undefined' || !('Notification' in window)) return null;
  if (isTwa()) return Notification.permission;
  if (Notification.permission !== 'default') return Notification.permission;
  try {
    return await Notification.requestPermission();
  } catch {
    return Notification.permission;
  }
};

export const isWebNotificationPromptNeeded = (): boolean => {
  if (typeof window === 'undefined' || !('Notification' in window)) return false;
  if (isTwa()) return false;
  return Notification.permission === 'default';
};
